define(["exports", "styled-components", "../Tab", "../../themes"], function (_exports, _styledComponents, _Tab, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TabBar = _exports.StyledTab = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);
  _Tab = _interopRequireDefault(_Tab);
  var StyledTab = (0, _styledComponents.default)(_Tab.default).withConfig({
    displayName: "StyledTab",
    componentId: "sc-1p6h7zy-0"
  })(["", ";border-radius:4px;color:", ";font-size:1.6em;font-weight:", ";line-height:1.5;margin-bottom:8px;outline:none;padding:8px;position:relative;+ button{margin-left:16px;}&[aria-selected='true'],&:hover,&:focus{font-weight:", ";}&:focus{", ";}&[aria-selected='true']{&::before{background-color:", ";content:'';height:4px;position:absolute;top:calc(100% + 7px);width:calc(100% - 16px);}}&::after{content:attr(title);display:block;font-weight:", ";height:0;overflow:hidden;visibility:hidden;}"], _themes.resetButton, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.dark;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.regular;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.semibold;
  }, _themes.focusBoxShadow, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.primary;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.semibold;
  });
  _exports.StyledTab = StyledTab;

  var TabBar = _styledComponents.default.div.withConfig({
    displayName: "StyledTab__TabBar",
    componentId: "sc-1p6h7zy-1"
  })(["border-bottom:2px solid ", ";padding-left:16px;padding-right:16px;"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.gray;
  });

  _exports.TabBar = TabBar;
});